import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import TemplateEntityEditingModal from 'components/views/admin/templates/single/templateEntityEditingModal/component';
import { STAGE_PLAY, STAGE_THEORY } from 'components/views/admin/templates/single/structure/constants';
import { sortStagesByOrdinal } from 'helpers/stageUtilities';
import { secToMins } from 'helpers/timeUtilities';
import StageForm from 'components/views/admin/templates/single/structure/stageForm/component';
import TemplateConfirmationModal from 'components/views/admin/templates/templateConfirmationModal/component';
import { adminRemoveStageAction, adminUpdateStageAction } from '../../../../../../redux/actions/admin/admin.stage.actions';
export default function TemplateStructure() {
    var dispatch = useDispatch();
    var template = useSelector(function (state) { return state.admin.singleTemplate; });
    var _a = useState([]), stages = _a[0], setStages = _a[1];
    var _b = useState(false), stageEditModalOpen = _b[0], setStageEditModalOpen = _b[1];
    var _c = useState(false), confirmModalOpen = _c[0], setConfirmModalOpen = _c[1];
    var _d = useState(null), openId = _d[0], setOpenId = _d[1];
    useEffect(function () {
        setStages(sortStagesByOrdinal(template === null || template === void 0 ? void 0 : template.stages));
        return function () { return setStages([]); };
    }, []);
    useEffect(function () {
        setStages(sortStagesByOrdinal(template === null || template === void 0 ? void 0 : template.stages));
    }, [template]);
    function onConfirmModalClose() {
        setConfirmModalOpen(false);
        setOpenId(null);
    }
    function onStageModifyClick(id) {
        setStageEditModalOpen(true);
        setOpenId(id);
    }
    function onStageDeleteClick(id) {
        setConfirmModalOpen(true);
        setOpenId(id);
    }
    function onStageConfirmDelete() {
        setConfirmModalOpen(false);
        dispatch(adminRemoveStageAction(openId));
    }
    function onModalClose() {
        setStageEditModalOpen(false);
        setOpenId(null);
    }
    if (!template)
        return null;
    return (React.createElement("div", null,
        React.createElement("ul", { className: "list-styles-clear" }, stages.map(function (stage) {
            var _a, _b, _c;
            return (React.createElement("li", { className: "mar-bottom-5 mar-top-5", key: stage._id },
                React.createElement("span", { style: { display: 'inline-block', width: 300 } },
                    stage.ordinal,
                    ".)\u00A0", (_c = (_b = (_a = stage.title) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.value) !== null && _c !== void 0 ? _c : '',
                    ",\u00A0",
                    secToMins(stage.duration),
                    "\u00A0min, (",
                    stage.discussion_break ? STAGE_THEORY : STAGE_PLAY,
                    ")"),
                React.createElement("button", { className: "main-button mar-left-10 mar-right-10", onClick: function () { return onStageModifyClick(stage._id); } }, "modify"),
                React.createElement("button", { className: "main-button main-button--error", onClick: function () { return onStageDeleteClick(stage._id); } }, "delete")));
        })),
        React.createElement(TemplateEntityEditingModal, { stageEditModalOpen: stageEditModalOpen, onModalClose: onModalClose },
            React.createElement(StageForm, { stages: stages, stage: template.stages.find(function (s) { return openId === s._id; }), onModalClose: onModalClose })),
        React.createElement(TemplateConfirmationModal, { modalOpen: confirmModalOpen, onModalClose: onConfirmModalClose },
            React.createElement("div", null,
                React.createElement("h2", null,
                    "Oled kindel et soovid kustutada m\u00E4ngu etappi ",
                    getStageTitle(openId, template.stages),
                    "?"),
                React.createElement("div", { className: "d-flex mar-top-20 justify-content-center flex-gap-10" },
                    React.createElement("button", { className: "main-button", onClick: onConfirmModalClose }, "Sulge"),
                    React.createElement("button", { className: "main-button main-button--error", onClick: onStageConfirmDelete }, "Kinnita")))),
        React.createElement("button", { className: "main-button", onClick: function () { return setStageEditModalOpen(true); } }, "Lisa m\u00E4ngu etapp")));
}
function getStageTitle(id, stages) {
    var _a, _b, _c;
    var stage = stages === null || stages === void 0 ? void 0 : stages.find(function (s) { return s._id === id; });
    return (_c = (_b = (_a = stage === null || stage === void 0 ? void 0 : stage.title) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.value) !== null && _c !== void 0 ? _c : '';
}
